import { GET_TRANSACTION } from '../actions';

export default function(state=null, action){
  switch (action.type) {
    case GET_TRANSACTION:
      if(action.payload.data === undefined){
        return null;
      }
      if(action.payload.data.response_code !== "00"){
        return { error: "Transacción no aprobada, vuelva a intentarlo más tarde" };
      }
      return action.payload.data;
    default: break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/buy_details_reducer.js